import { useCallback, useState } from "react";

export function useCommandSubmit() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = useCallback(
    async (input: string) => {
      const text = input.trim();
      if (!text || isSubmitting) return;

      setIsSubmitting(true);
      try {
        // TODO: 서버 연동 시 → LLM 호출(await) 후 결과 페이지로 이동
        console.log("[명령 실행]", text);
      } finally {
        setIsSubmitting(false);
      }
    },
    [isSubmitting]
  );

  return { submit, isSubmitting };
}
